<template>
    <views>
        <nav-bar
            title="中奖消息"
            fixed
            @click-left="onClickLeft">
        </nav-bar>
        <views class="gift">
            <van-list
                v-model="loadingData"
                :finished="finished"
                finished-text="没有更多了"
                @load="onLoad">
                <views
                    v-for="(item, index) in list"
                    :key="index"
                    class="gift-list"
                    @click="handleDetail(item)">
                    <views class="con">
                        恭喜您获得
<!--    TODO 1230:1                   -->
<!--                        <views v-if="item.gift_amount > 0" class="gift-list-count">{{ item.gift_amount }}元</views>-->
                        {{ item.gift_name }}
                    </views>
                    <views class="time">{{ item.created_at }}</views>
                </views>
            </van-list>
        </views>
    </views>
</template>

<script>
import NavBar from '@/components/navBar'
import tools from '@/mixins/tools'
import api from '@/utils/api'
import storage from '@/utils/storage'
export default {
    components: {
        NavBar
    },
    mixins: [tools],
    data() {
        return {
            loadingData: false,
            finished: false,
            pageNum: 1,
            list: []
        }
    },
    methods: {
        onClickLeft() {
            this.back()
        },
        handleDetail(row) {
            this.push(`/gift-detail?id=${row.id}`)
        },
        onLoad() {
            const params = {
                member_id: JSON.parse(storage.get('member')).id,
                page: this.pageNum,
                page_size: 10
            }
            api.getMemberPrizeList(params).then((res) => {
                if (res.data.list && res.data.list.length > 0) {
                    res.data.list.forEach((item) => {
                        this.list.push({ ...item })
                    })
                    this.pageNum++
                    this.loadingData = false
                    if (res.data.list.length < 10) {
                        this.finished = true
                    }
                } else {
                    this.finished = true
                }
            })
        }
    }
}
</script>

<style lang="scss" scoped>
@import './index.scss';
</style>
